import React from 'react';
import styled from 'styled-components';

const DotContainer = styled.path`
  border-radius: 50%;
  width: ${(props) => (props.focused ? '10px' : '10px')};
  height: ${(props) => (props.focused ? '10px' : '10px')};
  fill: ${(props) => props.fill};
`;

const Dot = ({ x, y, set }) => {
  return (
    <DotContainer
      x={x}
      y={y}
      fill={set.focused ? 'white' : 'black'}
      stroke="#e25d34"
      strokeWidth={set.focused ? '3' : 0}
      width={set.focused ? 16 : 10}
      height={set.focused ? 16 : 10}
      transform={`translate(${x}, ${y})`}
      d={`M${set.focused ? 5 : 5},0A${set.focused ? 5 : 5},${
        set.focused ? 5 : 5
      },0,1,1,-${set.focused ? 5 : 5},0A${set.focused ? 5 : 5},${
        set.focused ? 5 : 5
      },0,1,1,${set.focused ? 5 : 5},0`}
    >
      <g cx={x} cy={y} stroke="white" strokeWidth="5" fill="white" />
    </DotContainer>
  );
};

export default Dot;
